<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
       <span slot="tab">
         <a-icon type="container" />
           Beneficios flexibles
       </span>
        <a-card>
          <g-master name="beneficios"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :parentData="parentData"
                    @action="masterAction"
                    modalWidth="90%"
          >
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in master.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha inicial')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   :disabled="isedit"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['init_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Fecha final')" v-bind="fiOptions">
                    <a-date-picker style="width: 100%"
                                   type="date"
                                   valueFormat="Y-MM-DD HH:mm:ss"
                                   v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="benefex_concept"
                              style="width: 100%"
                              :disabled="isedit"
                              :label="$t('Concepto')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_coc', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                              :params="typeParams">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                    <g-dropdown endpoint="benefex_concept"
                                style="width: 100%"
                                :label="$t('Concepto balance')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_coc_bal', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                                :params="typeParams">
                    </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Moneda')"
                              :formItemConfig="fiOptions"
                              :decorator="['currency', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                              :params="code_currency">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Beneficio mensual')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['beneflex', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Beneficio anual')">
                    <a-input-number style="width: 100%" step="1"
                                    v-decorator="['beneflex_anual', { rules: [{ required: false}] }]"
                                    :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    ></a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Estado')" :has-feedback="false">
                    <a-checkbox
                      v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Frecuencia')">
                    <a-input v-decorator="['frecuency']"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Comentario')">
                    <a-textarea autoSize
                                v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-card>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    props: ['empleadoseleccionado', 'tpay'],
    data () {
      return {
        isedit: false,
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'beneflex',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Concepto balance', dataIndex: 'coc_name_bal', sorter: true},
              {title: 'Fecha inicial', dataIndex: 'init_date_mask', sorter: true},
              {title: 'Fecha final', dataIndex: 'end_date_mask', sorter: true},
              {title: 'Moneda', dataIndex: 'currency', sorter: true},
              {title: 'Beneficio', dataIndex: 'beneflex', sorter: true},
              {title: 'Beneficio anual', dataIndex: 'beneflex_anual', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true},
              {title: 'Frecuencia', dataIndex: 'frecuency', sorter: true},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'beneflex'},
            {name: 'beneflex_anual'},
            {name: 'comments'},
            {name: 'currency'},
            {name: 'end_date'},
            {name: 'frecuency'},
            {name: 'id_coc'},
            {name: 'id_coc_bal'},
            {name: 'init_date'},
            {name: 'status'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.isedit = false
            break
          case 'masterEdit':
            this.isedit = true
            break
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      },
      typeParams () {
        return {type_pay: this.tpay}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/BeneficiosFlexibles.vue